import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  Categories,
  AddCategory,
  CategoryDetails,
  EditCategory,
  AddSubcategory
} from '@screens';

export type CategoriesStackParamList = {
  CategoriesList: undefined;
  CategoryDetails: { categoryId: string };
  AddCategory: undefined;
  EditCategory: { categoryId: string };
  AddSubcategory: { categoryId: string };
};

const Stack = createNativeStackNavigator<CategoriesStackParamList>();

const CategoriesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="CategoriesList" 
        component={Categories} 
      />
      <Stack.Screen 
        name="CategoryDetails" 
        component={CategoryDetails} 
      />
      <Stack.Screen 
        name="AddCategory" 
        component={AddCategory} 
      />
      <Stack.Screen 
        name="AddSubcategory" 
        component={AddSubcategory} 
      />
      <Stack.Screen 
        name="EditCategory" 
        component={EditCategory} 
      />
    </Stack.Navigator>
  );
};

export default CategoriesStackNavigator; 